
import { StoreContext } from '../../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { actionTypeConstants } from '../../../utils';
import { getBolSignatures } from '../../../graphql/getBolSignature.query';
import { deleteSign } from "../../../graphql/deleteBolSignature.mutation"
import { dataURItoBlob, getSignatureByIndex } from "../../../common/GlobalUtils";
import { getCustomerId } from '../../../utils/Utils';

function SignaturesHook() {
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);

    const callClearSignature = async (signRef?: any) => {
        if (signRef?.getUrl) {
            await deleteSign({
                customerId: getCustomerId(),
                bolId: 0,
                signatureName: signRef?.fileName
            });
            await updateSignatures();
        }
        return true
    }


    const updateSignatures = async () => {
        const params = {
            "customerId": getCustomerId()
        }
        if (!getCustomerId())
            return false;

        return await getBolSignatures(params).then((dataResults: any) => {
            if (dataResults) {
                dispatch({
                    type: actionTypeConstants.STORE_SIGNATURES_API,
                    payload: dataResults
                })
            }
            
            return dataResults;

        }).catch((error) => {
            console.error("getBolSignatures:", error);
        })
    }

    const uploadSignatureWithRetry: any = async (signByInd: any, endPoint: any, requestOptions: any, noOfRetries: number) => {

        const retryLimit = noOfRetries + 1;
        
        return await fetch(endPoint, requestOptions)
            .then(async (response: any) => {

                if (response?.ok) {

                    await updateSignatures();

                } else {
                    console.log("upload failed. so retrying again");
                    if (retryLimit <= 3) {
                        return await updateSignatures().then( latestSignatureURls => {

                            const signatureObj = getSignatureByIndex(latestSignatureURls, signByInd);

                            let newEndPoint: any = signatureObj?.putUrl || "";
                            return uploadSignatureWithRetry(signByInd, newEndPoint, requestOptions, retryLimit)
                        });

                    } else {
                        console.log("Max Retries limit for upload is reached");
                    }

                }

                return response;
            })
    }

    const uploadSignature = async (sign?: any, signByInd?: any) => {
        try {
            let imageURL = sign;
            const blob = dataURItoBlob(imageURL)
            var signature = new File([blob], "");
            const requestOptions: any = {
                method: "PUT",
                body: signature,
                redirect: "follow",
            };
            let endPoint: any = signByInd?.putUrl || "";
            if (!endPoint)
                return false
            
            return uploadSignatureWithRetry(signByInd?.sequence, endPoint, requestOptions, 1);

        } catch(e){
            console.log(e);
        }
        return false

    }
    return [callClearSignature, updateSignatures, uploadSignature] as const;

}

export default function useSiganture() {

    const [callClearSignature, updateSignatures, uploadSignature] = SignaturesHook();
    return { callClearSignature, updateSignatures, uploadSignature }
}